<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Descripción -->
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.Descripcion"
          label="Descripción:"
          clearable
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Tipo Envio -->
      <v-col cols="12" sm="7" md="7">
        <v-autocomplete
          v-model="editedItem.TipoEnvio"
          :items="
            ArraTipoEnvio.map((x) => ({
              ...x,
              Valor: Number(x.Valor),
            }))
          "
          :item-title="
            (ArraTipoEnvio) => ArraTipoEnvio.Valor + '-' + ArraTipoEnvio.Descripcion
          "
          item-value="Valor"
          label="Tipo Envío:"
          dense
          clearable
          :rules="[rules.required]"
          @update:modelValue="ChangeTipoEnvio()"
        >
        </v-autocomplete>
      </v-col>

      <!-- Tipo Calculo Días -->
      <v-col v-if="editedItem.TipoEnvio == TipoEnvio.Programado" cols="12" sm="3" md="3">
        <v-autocomplete
          v-model="editedItem.TipoDiasEnvio"
          :items="ArrayCalculoDias"
          :item-title="
            (ArrayCalculoDias) =>
              ArrayCalculoDias.Valor + '-' + ArrayCalculoDias.Descripcion
          "
          item-value="Valor"
          label="Tipo Cálculo Días:"
          dense
          clearable
          :rules="editedItem.TipoEnvio == TipoEnvio.Programado ? [rules.required] : []"
        >
        </v-autocomplete>
      </v-col>

      <!-- Cantidad de día programadas  -->
      <v-col v-if="editedItem.TipoEnvio == TipoEnvio.Programado" cols="12" sm="2" md="2">
        <v-text-field
          v-model="editedItem.DiasEnvio"
          label="Cantidad de Días Programadas:"
          clearable
          dense
          type="tel"
          v-on:keypress="isNumber()"
          maxlength="16"
          counter="16"
          :rules="editedItem.TipoEnvio == TipoEnvio.Programado ? [rules.required] : []"
        >
        </v-text-field>
      </v-col>

      <!-- Graba Trazabilidad -->
      <v-col cols="12" sm="6" md="6">
        <v-switch
          v-model="editedItem.GrabaTrazabilidad"
          color="red-darken-3"
          label="Graba Trazabilidad"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Estado -->
      <v-col cols="12" sm="6" md="6">
        <v-switch
          v-model="editedItem.Estado"
          color="red-darken-3"
          label="Estado"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <v-expansion-panels v-model="panel" multiple>
        <!-- Notificaciones Internas -->
        <v-expansion-panel>
          <v-expansion-panel-title
            ><h2 align="center">Notificaciones Internas</h2></v-expansion-panel-title
          >
          <v-expansion-panel-text>
            <v-row>
              <!-- SMS Interno -->
              <v-col cols="12" sm="3" md="3">
                <v-switch
                  v-model="editedItem.NotificacionSMSInterno"
                  color="red-darken-3"
                  label="SMS Interno"
                  hide-details
                  inset
                ></v-switch>
              </v-col>

              <!-- WhatsApp Interno -->
              <v-col cols="12" sm="3" md="3">
                <v-switch
                  v-model="editedItem.NotificacionWPInterno"
                  color="red-darken-3"
                  label="WhatsApp Interno"
                  hide-details
                  inset
                ></v-switch>
              </v-col>

              <!-- Email Interno -->
              <v-col cols="12" sm="3" md="3">
                <v-switch
                  v-model="editedItem.NotificacionEmailInterno"
                  color="red-darken-3"
                  label="Email Interno"
                  hide-details
                  inset
                  @update:modelValue="ChangeEmailInterno()"
                ></v-switch>
              </v-col>

              <!-- Llamada Interno -->
              <v-col cols="12" sm="3" md="3">
                <v-switch
                  v-model="editedItem.NotificacionCallInterno"
                  color="red-darken-3"
                  label="Llamada Interno"
                  hide-details
                  inset
                ></v-switch>
              </v-col>

              <!-- Destinatario interno -->
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete
                  v-model="editedItem.DestinatarioInterno"
                  :items="ArrayDestinatarioInt"
                  :item-title="
                    (ArrayDestinatarioInt) =>
                      ArrayDestinatarioInt.Valor + '-' + ArrayDestinatarioInt.Descripcion
                  "
                  item-value="Valor"
                  label="Destinatario interno:"
                  dense
                  clearable
                  :rules="
                    editedItem.NotificacionSMSInterno ||
                    editedItem.NotificacionWPInterno ||
                    editedItem.NotificacionEmailInterno ||
                    editedItem.NotificacionCallInterno
                      ? [rules.required]
                      : []
                  "
                >
                </v-autocomplete>
              </v-col>

              <!-- Grupo Usuario Interno -->
              <v-col
                v-if="editedItem.DestinatarioInterno == DestinoInt.GrupoUser"
                cols="12"
                sm="4"
                md="4"
              >
                <v-autocomplete
                  v-model="editedItem.GrupoUId"
                  :items="ArrayGroupUser"
                  :item-title="
                    (ArrayGroupUser) =>
                      ArrayGroupUser.GrupoUID + '-' + ArrayGroupUser.Descripcion
                  "
                  item-value="GrupoUID"
                  color="primary"
                  label="Grupo Usuario Interno: "
                  dense
                  hint="Digite Información"
                  :rules="
                    editedItem.DestinatarioInterno == DestinoInt.GrupoUser
                      ? [rules.required]
                      : []
                  "
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!-- Tipo texto interno -->
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete
                  v-model="editedItem.TypeTextInterno"
                  :items="ArraTipoText"
                  :item-title="
                    (ArraTipoText) => ArraTipoText.Valor + '-' + ArraTipoText.Descripcion
                  "
                  item-value="Valor"
                  label="Tipo de texto interno:"
                  dense
                  clearable
                  :rules="
                    editedItem.NotificacionSMSInterno ||
                    editedItem.NotificacionWPInterno ||
                    editedItem.NotificacionEmailInterno ||
                    editedItem.NotificacionCallInterno
                      ? [rules.required]
                      : []
                  "
                  @update:modelValue="ChangeTipoTextoInterno()"
                >
                </v-autocomplete>
              </v-col>

              <!-- Documento Asunto Interno -->
              <v-col
                v-if="
                  editedItem.TypeTextInterno == TipoText.Plantilla &&
                  editedItem.NotificacionEmailInterno
                "
                cols="12"
                sm="4"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DocumentoIDAsuntoInterno"
                  :items="ArrayDocument"
                  :item-title="
                    (ArrayDocument) =>
                      ArrayDocument.DocumentoID + '-' + ArrayDocument.Descripcion
                  "
                  item-value="DocumentoID"
                  label="Documento Asunto Interno:"
                  dense
                  :rules="
                    editedItem.TypeTextInterno == TipoText.Plantilla &&
                    editedItem.NotificacionEmailInterno
                      ? [rules.required]
                      : []
                  "
                >
                </v-autocomplete>
              </v-col>

              <!-- Documento Interno -->
              <v-col
                v-if="editedItem.TypeTextInterno == TipoText.Plantilla"
                cols="12"
                sm="4"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DocumentoIDInterno"
                  :items="ArrayDocument"
                  :item-title="
                    (ArrayDocument) =>
                      ArrayDocument.DocumentoID + '-' + ArrayDocument.Descripcion
                  "
                  item-value="DocumentoID"
                  label="Documento Interno:"
                  dense
                  :rules="
                    editedItem.TypeTextInterno == TipoText.Plantilla
                      ? [rules.required]
                      : []
                  "
                >
                </v-autocomplete>
              </v-col>

              <!-- Texto Asunto Interno -->
              <v-col
                v-if="
                  editedItem.TypeTextInterno == TipoText.Escrito &&
                  editedItem.NotificacionEmailInterno
                "
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  v-model="editedItem.TextoAsuntoInterno"
                  label="Texto Asunto Interno:"
                  clearable
                  dense
                  maxlength="200"
                  counter="200"
                  hint="Digite Información"
                  :rules="
                    editedItem.TypeTextInterno == TipoText.Escrito &&
                    editedItem.NotificacionEmailInterno
                      ? [rules.required]
                      : []
                  "
                >
                </v-text-field>
              </v-col>

              <!-- Texto Interno -->
              <v-col
                v-if="editedItem.TypeTextInterno == TipoText.Escrito"
                cols="12"
                sm="6"
                md="12"
              >
                <v-textarea
                  v-model="editedItem.TextoInterno"
                  name="input-5-1"
                  filled
                  label="Texto Interno:"
                  auto-grow
                  clearable
                  counter="1000"
                  :rules="
                    editedItem.TypeTextInterno == TipoText.Escrito ? [rules.required] : []
                  "
                ></v-textarea>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <!-- Notificaciones Externas -->
        <v-expansion-panel>
          <v-expansion-panel-title
            ><h2 align="center">Notificaciones Externas</h2></v-expansion-panel-title
          >
          <v-expansion-panel-text>
            <v-row>
              <!-- SMS Externo -->
              <v-col cols="12" sm="3" md="3">
                <v-switch
                  v-model="editedItem.NotificacionSMSExterno"
                  color="red-darken-3"
                  label="SMS Externo"
                  hide-details
                  inset
                  @update:modelValue="ChangeDatoSMS()"
                ></v-switch>
              </v-col>

              <!-- WhatsApp Externo -->
              <v-col cols="12" sm="3" md="3">
                <v-switch
                  v-model="editedItem.NotificacionWPExterno"
                  color="red-darken-3"
                  label="WhatsApp Externo"
                  hide-details
                  inset
                  @update:modelValue="ChangeDatoWP()"
                ></v-switch>
              </v-col>

              <!-- Email Externo -->
              <v-col cols="12" sm="3" md="3">
                <v-switch
                  v-model="editedItem.NotificacionEmailExterno"
                  color="red-darken-3"
                  label="Email Externo"
                  hide-details
                  inset
                  @update:modelValue="ChangeDatoEmail()"
                ></v-switch>
              </v-col>

              <!-- Llamada Externo -->
              <v-col cols="12" sm="3" md="3">
                <v-switch
                  v-model="editedItem.NotificacionCallExterno"
                  color="red-darken-3"
                  label="Llamada Externo"
                  hide-details
                  inset
                ></v-switch>
              </v-col>

              <!-- Destinatario Externo -->
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  v-model="editedItem.DestinatarioExterno"
                  :items="ArrayDestinatarioExt"
                  :item-title="
                    (ArrayDestinatarioExt) =>
                      ArrayDestinatarioExt.Valor + '-' + ArrayDestinatarioExt.Descripcion
                  "
                  item-value="Valor"
                  label="Destinatario Externo:"
                  dense
                  clearable
                  :rules="
                    editedItem.NotificacionWPExterno ||
                    editedItem.NotificacionEmailExterno ||
                    editedItem.NotificacionSMSExterno ||
                    editedItem.NotificacionCallExterno
                      ? [rules.required]
                      : []
                  "
                  @update:modelValue="ChangeTipoDestinatarioExterno()"
                >
                </v-autocomplete>
              </v-col>

              <!-- Datos SMS 1 -->
              <v-col
                v-if="
                  (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                    editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                    editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                  editedItem.NotificacionSMSExterno
                "
                cols="12"
                sm="6"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DatoComunicacionSMS"
                  :items="ArrayDato"
                  :item-title="(ArrayDato) => ArrayDato.Codigo + '-' + ArrayDato.Label"
                  item-value="Codigo"
                  color="primary"
                  label="Datos SMS 1: "
                  dense
                  hint="Digite Información"
                  :rules="
                    (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                      editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                      editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                    editedItem.NotificacionSMSExterno
                      ? [rules.required]
                      : []
                  "
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!-- Datos SMS 2 -->
              <v-col
                v-if="
                  (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                    editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                    editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                  editedItem.NotificacionSMSExterno
                "
                cols="12"
                sm="6"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DatoComunicacionSMS2"
                  :items="ArrayDato"
                  :item-title="(ArrayDato) => ArrayDato.Codigo + '-' + ArrayDato.Label"
                  item-value="Codigo"
                  color="primary"
                  label="Datos SMS 2: "
                  dense
                  hint="Digite Información"
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!-- Datos WhatsApp 1 -->
              <v-col
                v-if="
                  (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                    editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                    editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                  editedItem.NotificacionWPExterno
                "
                cols="12"
                sm="6"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DatoComunicacionWP"
                  :items="ArrayDato"
                  :item-title="(ArrayDato) => ArrayDato.Codigo + '-' + ArrayDato.Label"
                  item-value="Codigo"
                  color="primary"
                  label="Datos WhatsApp 1: "
                  dense
                  hint="Digite Información"
                  :rules="
                    (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                      editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                      editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                    editedItem.NotificacionWPExterno
                      ? [rules.required]
                      : []
                  "
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!-- Datos WhatsApp 2 -->
              <v-col
                v-if="
                  (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                    editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                    editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                  editedItem.NotificacionWPExterno
                "
                cols="12"
                sm="6"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DatoComunicacionWP2"
                  :items="ArrayDato"
                  :item-title="(ArrayDato) => ArrayDato.Codigo + '-' + ArrayDato.Label"
                  item-value="Codigo"
                  color="primary"
                  label="Datos WhatsApp 2: "
                  dense
                  hint="Digite Información"
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!-- Datos Email 1 -->
              <v-col
                v-if="
                  (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                    editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                    editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                  editedItem.NotificacionEmailExterno
                "
                cols="12"
                sm="6"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DatoComunicacionEmail"
                  :items="ArrayDato"
                  :item-title="(ArrayDato) => ArrayDato.Codigo + '-' + ArrayDato.Label"
                  item-value="Codigo"
                  color="primary"
                  label="Datos Email 1: "
                  dense
                  hint="Digite Información"
                  :rules="
                    (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                      editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                      editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                    editedItem.NotificacionEmailExterno
                      ? [rules.required]
                      : []
                  "
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!-- Datos Email 2 -->
              <v-col
                v-if="
                  (editedItem.DestinatarioExterno == DestinoExt.Procesos ||
                    editedItem.DestinatarioExterno == DestinoExt.UserContactoProceso ||
                    editedItem.DestinatarioExterno == DestinoExt.UserAsignado) &&
                  editedItem.NotificacionEmailExterno
                "
                cols="12"
                sm="6"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DatoComunicacionEmail2"
                  :items="ArrayDato"
                  :item-title="(ArrayDato) => ArrayDato.Codigo + '-' + ArrayDato.Label"
                  item-value="Codigo"
                  color="primary"
                  label="Datos Email 2:"
                  dense
                  hint="Digite Información"
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!-- Tipo texto Externo -->
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  v-model="editedItem.TypeTextExterno"
                  :items="ArraTipoText"
                  :item-title="
                    (ArraTipoText) => ArraTipoText.Valor + '-' + ArraTipoText.Descripcion
                  "
                  item-value="Valor"
                  label="Tipo de texto Externo:"
                  dense
                  clearable
                  :rules="
                    editedItem.NotificacionWPExterno ||
                    editedItem.NotificacionEmailExterno ||
                    editedItem.NotificacionSMSExterno ||
                    editedItem.NotificacionCallExterno
                      ? [rules.required]
                      : []
                  "
                  @update:modelValue="ChangeTipoTextoExterno()"
                >
                </v-autocomplete>
              </v-col>

              <!-- Documento Asunto Externo -->
              <v-col
                v-if="
                  editedItem.TypeTextExterno == TipoText.Plantilla &&
                  editedItem.NotificacionEmailExterno
                "
                cols="12"
                sm="6"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DocumentoIDAsuntoExterno"
                  :items="ArrayDocument"
                  :item-title="
                    (ArrayDocument) =>
                      ArrayDocument.DocumentoID + '-' + ArrayDocument.Descripcion
                  "
                  item-value="DocumentoID"
                  label="Documento Asunto Externo:"
                  dense
                  :rules="
                    editedItem.TypeTextExterno == TipoText.Plantilla &&
                    editedItem.NotificacionEmailExterno
                      ? [rules.required]
                      : []
                  "
                >
                </v-autocomplete>
              </v-col>

              <!-- Documento Externo -->
              <v-col
                v-if="editedItem.TypeTextExterno == TipoText.Plantilla"
                cols="12"
                sm="6"
                md="6"
              >
                <v-autocomplete
                  v-model="editedItem.DocumentoIDExterno"
                  :items="ArrayDocument"
                  :item-title="
                    (ArrayDocument) =>
                      ArrayDocument.DocumentoID + '-' + ArrayDocument.Descripcion
                  "
                  item-value="DocumentoID"
                  label="Documento Externo:"
                  dense
                  :rules="
                    editedItem.TypeTextExterno == TipoText.Plantilla
                      ? [rules.required]
                      : []
                  "
                >
                </v-autocomplete>
              </v-col>

              <!-- Texto Asunto Externo -->
              <v-col
                v-if="
                  editedItem.TypeTextExterno == TipoText.Escrito &&
                  editedItem.NotificacionEmailExterno
                "
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  v-model="editedItem.TextoAsuntoExterno"
                  label="Texto Asunto Externo:"
                  clearable
                  dense
                  maxlength="200"
                  counter="200"
                  hint="Digite Información"
                  :rules="
                    editedItem.TypeTextExterno == TipoText.Escrito &&
                    editedItem.NotificacionEmailExterno
                      ? [rules.required]
                      : []
                  "
                >
                </v-text-field>
              </v-col>

              <!-- Texto Externo -->
              <v-col
                v-if="editedItem.TypeTextExterno == TipoText.Escrito"
                cols="12"
                sm="6"
                md="12"
              >
                <v-textarea
                  v-model="editedItem.TextoExterno"
                  name="input-5-1"
                  filled
                  label="Texto Externo:"
                  auto-grow
                  clearable
                  counter="1000"
                  :rules="
                    editedItem.TypeTextExterno == TipoText.Escrito ? [rules.required] : []
                  "
                ></v-textarea>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  putUpdate,
  postInsert,
} from "@/views/TCI/Parametros/Notificaciones/NotificacionesService";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";
import {
  DestinoInt,
  DestinoExt,
  TipoText,
  TipoEnvio,
} from "@/views/TCI/Parametros/Constantes/ConstantesParametros";

export default {
  name: "notificacion-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
    userId: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      DestinoInt,
      DestinoExt,
      TipoText,
      TipoEnvio,
      panel: [1],
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        NotificacionId: 0,
        Descripcion: null,
        GrabaTrazabilidad: false,
        NotificacionSMSInterno: false,
        NotificacionWPInterno: false,
        NotificacionEmailInterno: false,
        TypeTextInterno: null,
        DocumentoIDInterno: null,
        TextoInterno: null,
        DocumentoIDAsuntoInterno: null,
        TextoAsuntoInterno: null,
        DestinatarioInterno: null,
        GrupoUId: null,
        NotificacionSMSExterno: false,
        DatoComunicacionSMS: null,
        DatoComunicacionSMS: null,
        NotificacionWPExterno: false,
        DatoComunicacionWP: null,
        DatoComunicacionWP2: null,
        NotificacionEmailExterno: false,
        DatoComunicacionEmail: null,
        DatoComunicacionEmail2: null,
        TypeTextExterno: null,
        TextoExterno: null,
        DocumentoIDExterno: null,
        DocumentoIDAsuntoExterno: null,
        TextoAsuntoExterno: null,
        DestinatarioExterno: null,
        TipoEnvio: null,
        DiasEnvio: null,
        TipoDiasEnvio: null,
        NotificacionCallExterno: false,
        NotificacionCallInterno: false,
        Estado: true,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        NotificacionId: 0,
        Descripcion: null,
        GrabaTrazabilidad: false,
        NotificacionSMSInterno: false,
        NotificacionWPInterno: false,
        NotificacionEmailInterno: false,
        TypeTextInterno: null,
        DocumentoIDInterno: null,
        TextoInterno: null,
        DocumentoIDAsuntoInterno: null,
        TextoAsuntoInterno: null,
        DestinatarioInterno: null,
        GrupoUId: null,
        NotificacionSMSExterno: false,
        DatoComunicacionSMS: null,
        DatoComunicacionSMS: null,
        NotificacionWPExterno: false,
        DatoComunicacionWP: null,
        DatoComunicacionWP2: null,
        NotificacionEmailExterno: false,
        DatoComunicacionEmail: null,
        DatoComunicacionEmail2: null,
        TypeTextExterno: null,
        TextoExterno: null,
        DocumentoIDExterno: null,
        DocumentoIDAsuntoExterno: null,
        TextoAsuntoExterno: null,
        DestinatarioExterno: null,
        TipoEnvio: null,
        DiasEnvio: null,
        TipoDiasEnvio: null,
        NotificacionCallExterno: false,
        NotificacionCallInterno: false,
        Estado: true,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayDocument: [],
      ArrayGroupUser: [],
      ArrayDato: [],
      ArraTipoText: [],
      ArraTipoEnvio: [],
      ArrayCalculoDias: [],
      ArrayDestinatarioInt: [],
      ArrayDestinatarioExt: [],
      ArrayEstado: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",

        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Correo electrónico inválido",
      },
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Consultas a Ejecutar
      var userperfil = this.$store.getters.userperfil;
      this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

      if (this.editedIndex != -1) {
        this.putRegistro();
      } else {
        this.postRegistro();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postInsert(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putUpdate(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    // Cambio Tipo Envio
    ChangeTipoEnvio() {
      this.editedItem.DiasEnvio = null;
      this.editedItem.TipoDiasEnvio = null;
    },

    // Cambio Tipo Texto Interno
    ChangeTipoTextoInterno() {
      this.editedItem.DocumentoIDInterno = null;
      this.editedItem.TextoInterno = null;
      this.editedItem.DocumentoIDAsuntoInterno = null;
      this.editedItem.TextoAsuntoInterno = null;
    },

    // Cambio Tipo Texto Interno
    ChangeTipoTextoExterno() {
      this.editedItem.DocumentoIDExterno = null;
      this.editedItem.DocumentoIDAsuntoExterno = null;
      this.editedItem.TextoAsuntoExterno = null;
      this.editedItem.TextoExterno = null;
    },

    // Cambio Tipo Texto Interno
    ChangeTipoDestinatarioExterno() {
      this.editedItem.DatoComunicacionSMS = null;
      this.editedItem.DatoComunicacionSMS2 = null;
      this.editedItem.DatoComunicacionWP = null;
      this.editedItem.DatoComunicacionWP2 = null;
      this.editedItem.DatoComunicacionEmail = null;
      this.editedItem.DatoComunicacionEmail2 = null;
    },

    // Cambio Dato SMS
    ChangeDatoSMS() {
      this.editedItem.DatoComunicacionSMS = null;
      this.editedItem.DatoComunicacionSMS2 = null;
    },

    // Cambio Dato WP
    ChangeDatoWP() {
      this.editedItem.DatoComunicacionWP = null;
      this.editedItem.DatoComunicacionWP2 = null;
    },

    // Cambio Dato Email
    ChangeDatoEmail() {
      this.editedItem.TextoAsuntoExterno = null;
      this.editedItem.DocumentoIDAsuntoExterno = null;
      this.editedItem.DatoComunicacionEmail = null;
      this.editedItem.DatoComunicacionEmail2 = null;
    },

    // Cambio Email Interno
    ChangeEmailInterno() {
      this.editedItem.TextoAsuntoInterno = null;
      this.editedItem.DocumentoIDAsuntoInterno = null;
    },

    // Cargue Combos
    CargueCombos() {
      var Tables = this.$store.getters.MTablaSeleccion;

      var GroupUser = this.$store.getters.MGroupUsers;
      this.ArrayGroupUser = GroupUser;

      var Document = this.$store.getters.MDocumentos;
      this.ArrayDocument = Document;

      var datos = this.$store.getters.MDatos;
      this.ArrayDato = datos;

      this.ArraTipoText = Tables.filter(
        (item) =>
          item.Valor != null && item.TablaId == TablaSeleccion.TipoTextoNotificacion
      );

      this.ArraTipoEnvio = Tables.filter(
        (item) =>
          item.Valor != null && item.TablaId == TablaSeleccion.TipoEnvioNotificacion
      );

      this.ArrayCalculoDias = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.CalculoDias
      );

      this.ArrayDestinatarioInt = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.DestinatarioInt
      );

      this.ArrayDestinatarioExt = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.DestinatarioExt
      );

      this.ArrayEstado = Tables.filter(
        (item) =>
          item.Valor != null && item.TablaId == TablaSeleccion.EstadoActivoInactivo
      );
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
